import React from 'react';
import ThemeCustomization from './themes';
import Routes from './routes';
import { AuthProvider } from './contexts/AuthContext';
import { Toaster } from './components/ui/toaster';

// ==============================|| APP - WITH AUTH ||============================== //

const App = () => {
  return (
    <AuthProvider>
      <ThemeCustomization>
        <Routes />
        <Toaster />
      </ThemeCustomization>
    </AuthProvider>
  );
};

export default App;